<template>
  <div>
    <v-navigation-drawer
      :value="isAddNewEquipeSidebarActive"
      temporary
      touchless
      :right="!$vuetify.rtl"
      :width="$vuetify.breakpoint.smAndUp ? 350 : '100%'"
      app
      @input="val => $emit('update:is-add-new-equipe-sidebar-active', val)"
    >
      <v-card height="100%">
        <div class="drawer-header d-flex align-center mb-4">
          <span class="font-weight-semibold text-base text--primary">Associar Equipe</span>
          <v-spacer></v-spacer>
          <v-btn
            icon
            small
            @click="$emit('update:is-add-new-equipe-sidebar-active', false)"
          >
            <v-icon size="22">
              {{ icons.mdiClose }}
            </v-icon>
          </v-btn>
        </div>

        <v-card-text>
          <v-form
            ref="form"
            v-model="valid"
            @submit.prevent="onSubmit"
          >
            <v-select
              v-model="filaEquipeData"
              label="Equipes"
              :rules="[validators.select]"
              :items="equipesNaoAssociadas"
              item-text="nome"
              item-value="id"
              outlined
              dense
              return-object
              hide-details="auto"
              placeholder="Equipes"
              class="mb-6"
            >
            </v-select>

            <v-btn
              color="primary"
              class="me-3 mb-1"
              type="submit"
            >
              <v-progress-circular
                v-if="loadings"
                class="mx-6"
                indeterminate
                color="secundary"
              ></v-progress-circular>
              <span v-else> Associar </span>
            </v-btn>
            <v-btn
              color="secondary"
              class="mb-1"
              outlined
              type="reset"
              @click="resetEquipeData"
            >
              Cancelar
            </v-btn>
          </v-form>
        </v-card-text>
      </v-card>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { required, select } from '@core/utils/validation'
import { mdiClose, mdiEyeOffOutline, mdiEyeOutline } from '@mdi/js'
import { ref } from '@vue/composition-api'
import router from '@/router'
import FilaService from '@/services/modules/FilaService'

export default {
  model: {
    prop: 'isAddNewEquipeSidebarActive',
    event: 'update:is-add-new-equipe-sidebar-active',
  },
  props: {
    isAddNewEquipeSidebarActive: {
      type: Boolean,
      required: true,
    },
  },

  data: () => ({
    loading: true,
    equipesNaoAssociadas: [],
  }),

  watch: {
    isAddNewEquipeSidebarActive() {
      this.getEquipesNaoAssociadas()
    },
  },

  mounted() {
    this.getEquipesNaoAssociadas()
  },

  methods: {
    async getEquipesNaoAssociadas() {
      this.equipesNaoAssociadas = await FilaService.getEquipesNaoAssociadas(router.currentRoute.params.id)
    },
  },

  setup(props, { emit }) {
    const blankFilaEquipeData = {
      id: 0,
    }

    const valid = ref(false)
    const form = ref(null)

    const loadings = ref(false)

    const validate = () => {
      form.value.validate()
    }

    const resetForm = () => {
      form.value.reset()
    }

    const filaEquipeData = ref(JSON.parse(JSON.stringify(blankFilaEquipeData)))
    const errorMsg = ref('Entre em contato com o servidor.')
    const resetEquipeData = () => {
      filaEquipeData.value = JSON.parse(JSON.stringify(blankFilaEquipeData))
      resetForm()
      setTimeout(() => {
        emit('update:is-add-new-equipe-sidebar-active', false)
      }, 2000)
    }

    const onSubmit = async () => {
      loadings.value = !loadings.value

      if (valid.value) {
        const data = {
          equipeId: filaEquipeData.value.id,
        }

        try {
          await FilaService.createFilaEquipe(router.currentRoute.params.id, data)

          loadings.value = !loadings.value
          emit('refetch-data')
          resetEquipeData()
        } catch {
          loadings.value = !loadings.value
        }
      } else {
        loadings.value = !loadings.value
        validate()
      }
    }

    return {
      resetEquipeData,
      onSubmit,
      validate,
      form,
      filaEquipeData,
      valid,
      blankFilaEquipeData,
      loadings,
      errorMsg,

      // validation
      validators: {
        required,
        select,
      },
      icons: {
        mdiClose,
        mdiEyeOffOutline,
        mdiEyeOutline,
      },
    }
  },
}
</script>
